import { withTranslation } from "react-i18next";
import { Modal } from "reactstrap";
import { ModalBody } from "reactstrap";
import crossIcon from "assets/images/cross.svg";
import styles from "./../Notes.module.scss";
import { Fragment, useMemo } from "react";
import Empty from "components/Empty";
import StaffDefaultImage from "assets/images/staff-default-rounded.png";
import Text from "components/Text";

function StaffModel({
  t,
  isModalOpen,
  closeModal,
  handleApply,
  handleCancel,
  handleStaffSelection,
  allMembersList,
  selectedStaff,
  formOnly,
  setAddOfficeView,
  handleSubmit,
  errors,
}) {
  const { lightBtnClass, highLightBtn } = useMemo(
    () => ({
      lightBtnClass:
        "mb-md-3 button button-round button-border btn-mobile-link button-dark",
      highLightBtn: "button button-round button-shadow mr-md-4 mb-3",
    }),
    []
  );
  const viewListing = (
    <>
      <h3 className={formOnly ? "text-dark cfs-lg" : styles["modal_heading"]}>
        {t(`notes.${formOnly ? "assignStaffMember" : "selectStaffMember"}`)}
      </h3>
      <ul className="modal-employee-list group-list">
        {allMembersList?.length > 0 ? (
          allMembersList.map((item, i) => {
            return (
              <li key={item?.id}>
                <div className={`${styles.border_list} ch-radio`}>
                  <label onClick={() => handleStaffSelection(item)}>
                    <input
                      type="radio"
                      name="blockTimeslotAllDoctors"
                      checked={selectedStaff?.id === item?.id}
                      readOnly
                    />
                    <span className="d-flex">
                      <img
                        src={item?.profilePic || StaffDefaultImage}
                        alt="profile-pic"
                        className={styles.Default_staff_image}
                      />
                      <div>
                        {`${item?.firstName || ""} ${item?.lastName || ""}`}
                        <Text size="12px" weight="400" color="#87928D">
                          {item?.designation?.name ? item.designation.name : ""}
                        </Text>
                      </div>
                    </span>
                  </label>
                </div>
              </li>
            );
          })
        ) : (
          <li>
            <div className="ch-checkbox">
              <label>
                <Empty Message={t("notes.noStaffMemberFound")} />
              </label>
            </div>
          </li>
        )}
      </ul>
      {/* {allMembersList.length === 0 ? (
        <div className={styles["not_found"]}>
          <Empty Message={t("notes.noStaffMemberFound")} />
        </div>
      ) : (
        allMembersList?.map((staff) => (
          <div
            key={staff?.id}
            className={`${styles["staff_popup_wrapper"]} ch-radio`}
          >
            <label
              className="mr-5 pt-3 pb-3"
              onClick={() => handleStaffSelection(staff)}
            >
              <input
                type="radio"
                name="blockTimeslotAllDoctors"
                checked={selectedStaff?.id === staff?.id}
                readOnly
              />
              <span> {staff?.firstName + " " + staff?.lastName} </span>
            </label>
          </div>
        ))
      )} */}
      {formOnly && errors?.selectedStaff && (
        <span className="error-msg">{errors.selectedStaff}</span>
      )}
      <div
        className={
          `${styles["btn_container"]} btn-box mt-4` +
          (formOnly ? " d-flex justify-content-between" : " d-md-flex")
        }
      >
        <button
          className={
            formOnly ? lightBtnClass + " m-0" : highLightBtn + " w-sm-100"
          }
          title="save"
          onClick={(e) => {
            if (formOnly) {
              setAddOfficeView(false);
            } else {
              handleApply(e);
            }
          }}
          disabled={
            formOnly ? false : allMembersList.length === 0 || !selectedStaff?.id
          }
        >
          {t(`notes.${formOnly ? "previousStep" : "apply"}`)}
        </button>
        <button
          className={formOnly ? highLightBtn : lightBtnClass}
          title="cancel"
          onClick={(e) => {
            if (formOnly) {
              handleSubmit(e);
            } else {
              handleCancel(e);
            }
          }}
        >
          {t(`notes.${formOnly ? "addNote" : "cancel"}`)}
        </button>
      </div>
    </>
  );
  if (formOnly) {
    return viewListing;
  }
  return (
    <Fragment>
      <Modal
        isOpen={isModalOpen}
        toggle={closeModal}
        className="modal-dialog-centered modal-lg"
        modalClassName="custom-modal"
      >
        <span className="close-btn" onClick={closeModal}>
          <img src={crossIcon} alt="close" />
        </span>
        <ModalBody>{viewListing}</ModalBody>
      </Modal>
    </Fragment>
  );
}

export default withTranslation()(StaffModel);
